import { useState, useRef } from 'react'
import { Modal, Button, Toast } from '@aptive-env/storybook'

import { License, SalesRepresentative } from 'interface'
import { deleteSalesRepresentativeLicense } from 'services'

interface IDeleteLicenseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onHideShow: (licenseId: number, isHidden: boolean) => void;
  license: License | null;
  salesRepresentative: SalesRepresentative | null;
}

const DeleteLicenseModal: React.FC<IDeleteLicenseModalProps> = ({ isOpen, onClose, onHideShow, license, salesRepresentative }) => {
  const [showDeleteToast, setShowDeleteToast] = useState(false)
  const [isDeleteCancelled, setIsDeleteCancelled] = useState(false)
  const isDeleteCancelledRef = useRef(isDeleteCancelled)
  isDeleteCancelledRef.current = isDeleteCancelled

  const handleDelete = async () => {
    setShowDeleteToast(true)
    onHideShow(license?.license_id || 0, true)
    
    setTimeout(() => {
      setShowDeleteToast(false)
      if(isDeleteCancelledRef.current) {
        setIsDeleteCancelled(false)
      } else {
        deleteSalesRepresentativeLicense(salesRepresentative!.id, license!.license_id)
          .then((deleteResponse) => {
            setIsDeleteCancelled(false)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }, 5000)

    onClose()
  }

  const handleUndoDelete = () => {
    setIsDeleteCancelled(true)
    setShowDeleteToast(false)
    onHideShow(license?.license_id || 0, false)
  }

  return (
    <>
      <Modal open={isOpen} onClickOutside={onClose} >
        <div className="flex flex-col w-[512px] p-6">
          <div className="text-lg leading-6 font-medium text-gray-900 mb-2">Delete License?</div>
          <div className="text-sm leading-5 text-gray-600 mb-4">
            Are you sure you want to delete this license? This action cannot be undone.
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="neutral" onClick={onClose}>
              Go back
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Delete License
            </Button>
          </div>
        </div>
      </Modal>
      <div className="fixed top-3 right-3 z-[100]">
        {
          showDeleteToast && (
            <Toast
              dismissible
              isIcon
              header="Success"
              isActionButton
              actionButtonTitle="Undo"
              onClickActionButton={handleUndoDelete}
              onDismiss={() => setShowDeleteToast(false)}
              status="success"
            >
              Well done, you successfully deleted a license.
            </Toast>
          )          
        }
      </div>
    </>
  )
}

export default DeleteLicenseModal
